/*
 * Copyright (c) 2022 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Injectable } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { environment } from '../../environments/environment';
// @ts-ignore
import { FabUser } from '../models/FabUser';

@Injectable()
export class AuthenticationService {
  // /** Observable which will return the user's information from the token */
  get userInfo(): FabUser {
    const claims = this.oAuthService.getIdentityClaims();
    return this.constructUserFromIdentityClaims(claims);
  }

  constructor(private readonly oAuthService: OAuthService) {}

  async initialize(): Promise<boolean> {
    console.log("Authentication service initialize ");
    this.oAuthService.configure(environment.auth);
    return this.oAuthService.loadDiscoveryDocumentAndLogin();
  }

  /**
   * Will setup up silent refreshing for when the token is about to expire.
   * When the user is logged out via this.logOut method, the silent refreshing will pause and not refresh the tokens
   * until the user is logged back in via receiving a new token.
   */
  enableSilentRenew(): void {
   // console.log("token expiration  "+this.oAuthService.getIdTokenExpiration());
    this.oAuthService.setupAutomaticSilentRefresh();
  }

  /**
   * Removes all tokens and logs the user out. If a logout url is configured,
   * the user is redirected to it.
   */
  logout(): void {
    this.oAuthService.logOut();
  }

  /**
   * Creates a FabUser.ts from the claims object passed in.
   *
   * @param claims Object consisting of the user's properties
   * @private
   */
  private constructUserFromIdentityClaims(claims: any): FabUser {
    let user: FabUser = {gmin:''};
    if (claims) {
      user = {
        gmin: claims.gmuniqueidentifier ?? '',
        firstName: claims.givenName ?? '',
        lastName: claims.sn ?? '',
        displayName: claims.name ?? '',
        email: claims.email ?? '',
        roles: claims.roles ?? [],
        token: this.oAuthService.getAccessToken().trim()
      };
    }
    return user;
  }
}
